// extracted by mini-css-extract-plugin
export default {"closeButton":"TeamAddMembersDialog_closeButton__14ScD","endSelect":"TeamAddMembersDialog_endSelect__ouWbN","scrollBox":"TeamAddMembersDialog_scrollBox__BVLNE"};